<script>
  import parsePuzFile from "@dylanarmstrong/puz";
  import transformPuzFile from "./utils/transformPuzFile";
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  // Return FileReader result as a promise
  function getFileContents(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (e) => reject(e);
      reader.readAsArrayBuffer(file);
    });
  }

  async function handleUpload() {
    const contents = await getFileContents(this.files[0]);
    const data = new Uint8Array(contents);
    const puzzle = parsePuzFile(data);
    const grid = transformPuzFile(puzzle);

    dispatch("upload", grid);
  }
</script>

<input
  type="file"
  id="puz"
  accept="application/x-crossword"
  on:change={handleUpload} />
